export default __webpack_public_path__ + "static/media/house-blank-duotone.497b5408.svg";